import { generatePath, ROUTES } from 'libs/navigation';
import { Stack, Typography } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';
import { PropsWithTestAttribute } from 'types/testAttribute';

import { DirectoryItemStyled } from './DirectoryItem.styles';

export interface DirectoryItemProps extends PropsWithTestAttribute {
  directory: {
    id: string;
    label: string;
  };
  className?: string;
}

export const DirectoryItem = ({
  directory,
  className,
  datax,
}: DirectoryItemProps) => (
  <DirectoryItemStyled
    className={className}
    datax={datax}
    to={generatePath(ROUTES.directories.directory.fullPath, {
      schemaId: directory.id,
    })}
  >
    <Stack
      alignItems="center"
      direction="row"
      flex={1}
      justifyContent="space-between"
    >
      <Stack alignItems="center" direction="row" spacing={8}>
        <Icon.Directory />
        <Typography>{directory.label}</Typography>
      </Stack>
      <Icon.ArrowRight />
    </Stack>
  </DirectoryItemStyled>
);
